import { useEffect, useState } from 'react';
import ICON_GS from "../../imgComponents/icons/google_sheets.png";
import "./exportgs.css";
import MODAL_TABLE from '../modal/modal_Table';

export const Exportgs = (props) => {
    const [tokenClient, setTokenClient] = useState(null);
    const [access_token, setAccessToken] = useState(null);
    const [tokenReady, setTokenReady] = useState(false);
    const [bandera, setbandera] = useState(false);
    const [modalT, setmodalT] = useState(false);

    const CLIENT_ID = '301722987834-pec5a9vlojn6redpcneblrgd2ckqdj05.apps.googleusercontent.com';
    const API_KEY = 'AIzaSyCLbT_ImiBa4NBDDWrp1pgkFBbTxfBluRM';
    const DISCOVERY_DOCS = ["https://sheets.googleapis.com/$discovery/rest?version=v4"];

    useEffect(() => {
        const loadScripts = () => {
            const gapiScript = document.createElement("script");
            gapiScript.src = "https://apis.google.com/js/api.js";
            gapiScript.onload = () => {
                window.gapi.load("client", initGapiClient);
            };
            document.body.appendChild(gapiScript);

            const gisScript = document.createElement("script");
            gisScript.src = "https://accounts.google.com/gsi/client";
            gisScript.async = true;
            gisScript.defer = true;
            document.body.appendChild(gisScript);
        };

        const initGapiClient = async () => {
            await window.gapi.client.init({
                apiKey: API_KEY,
                discoveryDocs: DISCOVERY_DOCS,
            });

            const client = window.google.accounts.oauth2.initTokenClient({
                client_id: CLIENT_ID,
                scope: 'https://www.googleapis.com/auth/spreadsheets',
                prompt: 'consent',
                callback: (tokenResponse) => {
                    setAccessToken(tokenResponse.access_token);
                    window.gapi.client.setToken({ access_token: tokenResponse.access_token });
                    setTokenReady(true);
                },
            });

            setTokenClient(client);
        };

        loadScripts();
    }, []);

    async function datasheet() {
        setbandera(true);
        await props.handleshet();
    }

    function handledibujarsheet() {
        if (bandera && props.gs) {
            setmodalT(true);
            createSpreadsheetAndPopulateWithCsv(props.gs);
        }
    }

    useEffect(() => {
        handledibujarsheet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.gs]);

    useEffect(() => {
        if (tokenReady) {
            datasheet();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenReady]);

    function createSpreadsheetAndPopulateWithCsv(csv) {
        const spreadsheet = {
            properties: {
                title: props.nametable,
            },
            sheets: [
                {
                    properties: {
                        title: 'My Sheet',
                    },
                },
            ],
        };

        window.gapi.client.sheets.spreadsheets.create({
            resource: spreadsheet,
        }).then(response => {
            const spreadsheetId = response.result.spreadsheetId;
            const data = csv.split('\n').map(row => {
                const rowWithSpecialChars = row.replace(/"([^"]*)"/g, (match, p1) => {
                    const replaced = p1.replace(/,/g, '|');
                    return `"${replaced}"`;
                });
                return rowWithSpecialChars.split(',').map(value => {
                    const withoutQuotes = value.replace(/^"|"$/g, '');
                    return withoutQuotes.replace(/\|/g, ',');
                });
            });

            const range = 'My Sheet!A1';
            window.gapi.client.sheets.spreadsheets.values.update({
                spreadsheetId,
                range,
                valueInputOption: 'USER_ENTERED',
                resource: {
                    values: data,
                },
            }).then(() => {
                setbandera(false);
                setmodalT(false);
                const spreadsheetUrl = `https://docs.google.com/spreadsheets/d/${spreadsheetId}`;
                window.open(spreadsheetUrl, '_blank');
            });
        });
    }

    return (
        <>
            <img
                src={ICON_GS}
                className='icon-export-pdf'
                onClick={() => {
                    tokenReady ? datasheet() : tokenClient?.requestAccessToken();
                }}
                title="Exportar GSheets"
                alt=''
            />
            <MODAL_TABLE
                open={true}
                message={""}
                modalGeneral={false}
                modalT={modalT}
            />
        </>
    );
};
